import { JSX, useMemo } from 'react';
import { concepts } from "fearless-common";
import Description from "../components/Description";
import { FAQ, FAQS, FAQ_CATEGORIES } from "../libs/faqs";
import { Accordion } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useTitle from "../components/hooks/useTitle";

const keywords = [
  'Photo51',
  'Team Subscription',
  'Individual Subscription',
  'My Subscription',
  'Group',
  'Manage Teams',
  'free View-Only',
  'Free View-Only',
  'My Teams',
  'fearlessleague.com',
  'Import',
];

/** Highlights matching keywords in text by wrapping them in `<strong>` elements. */
function highlightKeywords(text: string, kw: string[]): (string | JSX.Element)[] {
    const pattern = new RegExp(`(${kw.join('|')})`, 'gi');
    return text.split(pattern).map((part, index) => {
        return kw.includes(part) ? <strong key={index}>{part}</strong> : part;
    });
}

/** FAQ page with entries grouped by category and keyword highlighting in answers. */
export default function FaqPage() {
    useTitle(`FAQs`);
    const hashMapPerTag = useMemo(() => {
        return FAQS.reduce<Record<string, FAQ[]>>((acc, o) => {
            o.tags?.forEach((tagValue) => {
                if (!acc[tagValue]) {
                    acc[tagValue] = [];
                }
                acc[tagValue].push(o);
            });
            return acc;
        }, {});
    }, []);

    return (
        <Container>
            <Row className="mb-5">
                <Col>
                    <div className="bg-lightest p-5 rounded-bottom-right-lg">
                        <h1>{concepts.FAQ}</h1>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm={8}>
                    {Object.keys(FAQ_CATEGORIES).map((key) => {
                        const value = FAQ_CATEGORIES[key as keyof typeof FAQ_CATEGORIES];
                        return (
                            <section key={value} className="mb-5">
                                <span id={key}></span>
                                <h3 className="pb-3">{value}</h3>
                                {hashMapPerTag[value]?.map(({ title, description, subDescription, mainDescription }) => (
                                    <Accordion key={title}>
                                        <Accordion.Header>{title}</Accordion.Header>
                                        <Accordion.Body className="pb-5">
                                            {mainDescription && (
                                                <Description>
                                                    <ul>
                                                        {mainDescription.map((text, index) => (
                                                            <li key={index}>{highlightKeywords(text, keywords)}</li>
                                                        ))}
                                                    </ul>
                                                </Description>
                                            )}
                                            {description.split('\n').map((text) => (
                                                <Description key={text}>
                                                    {highlightKeywords(text, keywords)}
                                                </Description>
                                            ))}
                                            {subDescription && (
                                                <Description>
                                                    <ul>
                                                        {subDescription.map((text, index) => (
                                                            <li key={index}>{highlightKeywords(text, keywords)}</li>
                                                        ))}
                                                    </ul>
                                                </Description>
                                            )}
                                        </Accordion.Body>
                                    </Accordion>
                                ))}
                            </section>
                        )
                    })}
                </Col>
            </Row>
        </Container>
    );
}
